import { adapter, BASKETS_FEATURE_KEY, BasketsPartialState, BasketsState } from './baskets.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getBasketsState = createFeatureSelector<
  BasketsPartialState,
  BasketsState
>(BASKETS_FEATURE_KEY);

const { selectAll, selectEntities } = adapter.getSelectors();

const getError = createSelector( getBasketsState, (state:BasketsState) => state.error );

const getAllBaskets = createSelector(
  getBasketsState,
  selectAll
);

const getAllBasketsById = createSelector(
  getBasketsState,
  selectEntities
);

const getLastCreatedId = createSelector( getBasketsState, (state:BasketsState) => state.lastCreatedId );

const getIsSearching = createSelector( getBasketsState, (state:BasketsState) => state.isSearching );

const getSearchResultIds = createSelector( getBasketsState, (state:BasketsState) => state.searchResultIds );

const getSearchResults = createSelector( getAllBasketsById, getSearchResultIds, (entities, searchResultIds) => {
  return searchResultIds.map(id => entities[id]);
});
const getDeliveryMethods = createSelector( getBasketsState, (state:BasketsState) => state.deliveryMethods );
const getPayments = createSelector( getBasketsState, (state:BasketsState) => state.payments );
const getSupportedPayments = createSelector( getBasketsState, (state:BasketsState) => state.supportedPayments );
const getRedirectUrl = createSelector( getBasketsState, (state:BasketsState) => state.redirectUrl );
const getOrder = createSelector( getBasketsState, (state:BasketsState) => state.order );
const getStep = createSelector(getBasketsState, (state: BasketsState) =>  state.step);

export const BasketsQuery = {
  getError,
  getAllBaskets,
  getAllBasketsById,
  getLastCreatedId,
  getIsSearching,
  getSearchResults,
  getDeliveryMethods,
  getPayments,
  getSupportedPayments,
  getRedirectUrl,
  getOrder,
  getStep
};
